import { config } from 'react-spring'
import CompactDrawer from './components/CompactDrawer'

const animationConfig = config
export { CompactDrawer, animationConfig }
